import { Check } from "lucide-react";
import { Section } from "@/components/partner/Section";

export default function FirstDay({ steps }) {
  const done = steps.filter((s) => s.done).length;
  return (
    <Section id="launch" eyebrow="Partner launch" title="Your first 24 hours" sub={done === steps.length ? "You've done it all. Welcome to the programme properly." : `${done} of ${steps.length} done.`}>
      <div className="h-1 rounded-full bg-white/10 overflow-hidden mb-6"><div className="h-full bg-primary transition-[width] duration-700" style={{ width: `${(done / steps.length) * 100}%` }} /></div>
      <ol className="space-y-2">
        {steps.map((s) => (
          <li key={s.key} className={`flex items-center gap-4 rounded-2xl border px-5 py-4 ${s.done ? "border-primary/30 bg-primary/[0.05]" : "border-border bg-card/30"}`} data-testid={`launch-step-${s.key}`}>
            <span className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 ${s.done ? "bg-primary text-primary-foreground" : "border border-border"}`}>{s.done && <Check className="w-4 h-4" />}</span>
            <span className={s.done ? "text-foreground" : "text-foreground/80"}>{s.label}</span>
            {s.done && <span className="ml-auto text-[10px] uppercase tracking-[0.18em] text-primary" data-testid={`launch-done-${s.key}`}>Done</span>}
          </li>
        ))}
      </ol>
    </Section>
  );
}
